import React from "react";
import { SafeAreaView, ScrollView } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import Header from "@/components/ui/Header";
import { Colors } from "@/constants/Colors";
import { BillNegotiatorCard } from "@/components/dashboard/BillNegotiatorCard";

const BillItemsScreen: React.FC = () => {
  return (
    <SafeAreaView style={styles.container}>
      <Header title="Bill Items" />

      <ScrollView
        style={styles.content}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={styles.scrollContent}
      >
        <BillNegotiatorCard />
      </ScrollView>
    </SafeAreaView>
  );
};

export default BillItemsScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.background,
  },
  content: {
    flex: 1,
  },
  scrollContent: {
    paddingTop: 16,
    paddingBottom: 24,
  },
});
